import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

export const auth = Object.freeze({
  async me(params) {
    const response = await axiosInstance.get(`${SERVER}/${CONSOLE_API_URL}/users/me`, { params })

    return response.data
  },
  async logout() {
    const response = await axiosInstance.get(`${SERVER}/${CONSOLE_API_URL}/oauth2/sign_out`)

    return response.data
  },
})
